/* eslint-disable react/display-name */
import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

const FlavourContext = createContext({ flavour: 'odl' });

export class Flavour extends Component {
  static defaultProps = {
    flavour: 'odl',
  };
  static propTypes = {
    flavour: PropTypes.string,
    children: PropTypes.node,
  };

  render() {
    return (
      <FlavourContext.Provider value={{ flavour: this.props.flavour }}>
        {this.props.children}
      </FlavourContext.Provider>
    );
  }
}

export const withFlavour = WrappedComponent => {
  const Wrapper = props => (
    <FlavourContext.Consumer>
      {({ flavour }) => {
        return <WrappedComponent flavour={flavour} {...props} />;
      }}
    </FlavourContext.Consumer>
  );

  Wrapper.displayName = `withFlavour(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;
  return Wrapper;
};

export const mergeStyles = (a, b) => {
  // while running jest, proxies are used instead of css modules.
  // so here we return the passe in proxy instead of merging strings
  // otherwise while cloning the proxied object (a) we end up with an empty object (no proxy, no getter, no value)
  // resulting in empty classnames <div className={styles.headerWrapper} /> renders <div className="" />
  if (process.env.NODE_ENV === 'test') return a;
  const res = { ...a };
  b &&
    Object.keys(b).forEach(
      key => (res[key] = res[key] ? `${res[key]} ${b[key]}` : b[key])
    );
  return res;
};

export const withFlavourCSS = (baseStyles, themes) => WrappedComponent => {
  const FlavourStyleComponent = props => (
    <FlavourContext.Consumer>
      {({ flavour }) => {
        const styles = mergeStyles(
          mergeStyles(baseStyles, themes[flavour]),
          props.styles
        );
        return <WrappedComponent styles={styles} {...props} />;
      }}
    </FlavourContext.Consumer>
  );

  FlavourStyleComponent.propTypes = {
    styles: PropTypes.object,
  };

  FlavourStyleComponent.displayName = `withFlavourCSS(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;
  return FlavourStyleComponent;
};
